import React from 'react';

const Color = ({ params }) => {
    const value = params?.value;

    if (!value) {
        return <></>;
    }

    return (
        <div className="colorbox" style={{ backgroundColor: value }} />
    );
};

export default Color;
